import styled from 'styled-components';
import { config } from '../../../../../../../components/dashboards/config';

const Style = styled.div`
  background: ${config.DASHBOARD_BACKGROUND};
  height: calc(100%);
  overflow-y: hidden;
  display: flex;
  flex-direction: column;

  .anticon-loading {
    color: var(--mmt-primary-70);
  }

  .tab-cont {
    padding: var(--size-lg);
    padding-top: 0px;
  }

  .main-container {
    flex: 1;
    overflow-y: auto;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .flex-1 {
    flex: 1;
  }
  
  .settings-header {
    padding: var(--size-lg) var(--size-lg) 0px var(--size-lg);
  }
`;

export default Style;
